import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from '../../environments/environment';
import {AccountInterfaceData, AccountInterfacePostData } from '../shared/models/account.model';

import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ForgotPasswordService {

  url:string = `${environment['API_URL']}`

  constructor(private http: HttpClient,) {
  }

  forgotPassword(endpoint: string, email: string){

    let url = `${this.url}/${endpoint}`;

    return this.http.post(url, {
      email: email
    },{  headers: { 'Content-Type': 'application/json'},observe: 'response' })
  } //end forgotPassword



} // end ForgotPasswordService
